import React from "react";
import { motion } from "framer-motion";
import { Layers, Users, Video, Mic, FileText, Target } from "lucide-react";

const items = [
  { icon: Layers, title: "Practical, Not Just Theoretical", body: "Training focuses on situations candidates actually experience." },
  { icon: Users, title: "Personal Attention", body: "Small batches allow trainers to understand individual weaknesses." },
  { icon: Video, title: "Mock Interview Practice", body: "Practice interviews before facing real recruiters." },
  { icon: Mic, title: "Communication + Interview Training", body: "Improve how you communicate as well as what you communicate." },
  { icon: FileText, title: "ATS Resume Guidance", body: "Develop cleaner, role-relevant and professional resumes." },
  { icon: Target, title: "Placement-Focused", body: "Training is structured around preparing you for hiring opportunities." },
];

export default function WhyUs() {
  return (
    <section className="py-24 sm:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.28em] uppercase text-slate-500">Why Be Hire Ready</div>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl leading-tight text-[#0B132B]">Training Designed Around Real Hiring Situations</h2>
        </div>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it, i) => (
            <motion.div key={it.title}
                        initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                        transition={{ delay: i * 0.06 }}
                        className="glass-light rounded-2xl p-6 shadow-soft hover:shadow-elev transition-shadow">
              <div className="h-10 w-10 rounded-xl bg-[#0B132B] text-white grid place-items-center">
                <it.icon size={16} />
              </div>
              <div className="mt-4 font-display text-lg text-[#0B132B]">{it.title}</div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
